module.exports = __webpack_public_path__ + "media/images/flag_au-ec3bbcf1999d1fb232e59f0bd232d7fd.png";